import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { FiArrowRight, FiPlay, FiCheckCircle, FiStar } from 'react-icons/fi';
import { useSiteContent } from '../context/SiteContentContext';

const Hero = ({
  badge: propBadge, title: propTitle, subtitle: propSubtitle, image: propImage,
  primaryBtnText: propPrimaryBtnText, primaryBtnLink = '/contact',
  secondaryBtnText: propSecondaryBtnText, secondaryBtnLink = '/about',
  rating: propRating = '4.9/5', clientCount: propClientCount = '49+ Worldwide', isHome = false
}) => {
  const { siteContent } = useSiteContent();
  const heroCms = isHome ? (siteContent?.hero || {}) : {};

  const badge = isHome ? heroCms.badge : propBadge;
  const subtitle = isHome ? heroCms.subtitle : propSubtitle;
  const primaryBtnText = isHome ? heroCms.primaryBtnText : propPrimaryBtnText;
  const secondaryBtnText = isHome ? heroCms.secondaryBtnText : propSecondaryBtnText;
  const image = isHome ? heroCms.heroImage : propImage;
  const finalRating = isHome ? heroCms.rating : propRating;
  const finalClientCount = isHome ? heroCms.clientCount : propClientCount;

  const renderTitle = () => {
    if (isHome) {
      return (
        <>
          {heroCms.titleLine1} <br />
          <span className="text-[#F2B135]">{heroCms.titleLine2}</span> <br />
          {heroCms.titleLine3}
        </>
      );
    }
    return propTitle;
  };
  const heroRef = useRef(null);
  const leftColRef = useRef(null);
  const rightColRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      tl.fromTo(leftColRef.current.children, { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, stagger: 0.15 }, 0.5);
      tl.fromTo(rightColRef.current, { x: 50, opacity: 0, scale: 0.95 }, { x: 0, opacity: 1, scale: 1, duration: 1 }, 0.8);
    }, heroRef);
    return () => ctx.revert();
  }, []);

  // ... (up ka code same rahega)

  return (
    <section ref={heroRef} className="relative min-h-0 pt-28 pb-8 md:min-h-screen md:pt-24 md:pb-12 overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full z-0">
        <video autoPlay loop muted playsInline className="object-cover w-full h-full opacity-100">
          <source src="/herovideo.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-black to-transparent z-10" />
      </div>

      {/* Yahan dekho: max-w-7xl aur mx-auto center karega isay navbar ke neeche */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 w-full flex flex-col justify-center">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* LEFT COLUMN */}
          <div ref={leftColRef} className="flex flex-col items-start text-left pt-10 lg:pt-0">
            {/* ... baaki content wahi rahega ... */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#F2B135]/30 bg-[#F2B135]/10 text-[#F2B135] text-xs font-bold uppercase mb-6 backdrop-blur-md">
              <span className="w-2 h-2 rounded-full bg-[#F2B135] animate-pulse" />
              {badge}
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black text-white leading-[1.1] mb-6">
              {renderTitle()}
            </h1>

            <p className="text-white/80 text-lg leading-relaxed mb-10 max-w-xl font-medium">
              {subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-5">
              <a href={primaryBtnLink} className="btn-animated-gold px-10 py-4 text-lg">
                {primaryBtnText} <FiArrowRight size={18} />
              </a>
              <a href={secondaryBtnLink} className="flex items-center gap-3 px-8 py-4 rounded-full text-white border border-white/20 hover:bg-white/10 transition-all">
                <FiPlay size={14} /> {secondaryBtnText}
              </a>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div ref={rightColRef} className="relative mt-10 lg:mt-0 flex justify-end">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl max-w-lg w-full">
              <img src={image} alt="Hero" className="w-full h-auto object-cover" />
            </div>

            {/* Absolute cards */}
            <div className="absolute top-0 -right-4 z-20 bg-black/60 backdrop-blur-xl border border-[#F2B135]/40 rounded-2xl p-4 flex items-center gap-4 shadow-xl">
              <div className="w-10 h-10 rounded-full bg-[#F2B135] flex items-center justify-center text-black font-black"><FiStar fill="currentColor" /></div>
              <div>
                <div className="text-white font-bold">{finalRating}</div>
                <div className="text-white/60 text-xs">Client Rating</div>
              </div>
            </div>

            <div className="absolute bottom-10 -left-4 z-20 bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-4 flex items-center gap-4 shadow-xl">
              <div className="text-white font-bold text-sm">Happy Clients</div>
              <div className="text-[#F2B135] font-bold">{finalClientCount}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Hero;